export default __webpack_public_path__ + "static/media/welcome-image.ed0976c8.svg";